var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "autocomplete" },
    [
      _vm._v(
        "\n  " +
          _vm._s(_vm.$t("Test")) +
          "\n  " +
          _vm._s(_vm.$t("Test2")) +
          "\n  "
      ),
      _c("AutocompleteForm", {
        attrs: {
          autocompleteUrl: _vm.autocompleteUrl,
          placeholder: _vm.input.placeholder,
        },
        on: { searched: _vm.setMatches },
        model: {
          value: _vm.keyword,
          callback: function ($$v) {
            _vm.keyword = $$v
          },
          expression: "keyword",
        },
      }),
      _vm._v(" "),
      _vm.isOpen
        ? _c("AutocompleteResults", {
            attrs: {
              isOpen: _vm.visibleForm,
              matches: _vm.matches,
              keyword: _vm.keyword,
              totals: _vm.totals,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }